import cx from './menuButton.less';
import { Component, React } from '../react';
import FocusLockFocusGuard from '../focuslock/focuslockext';
import Wrapper from '../focuslock/wrapper';
import UPDATE_BUTTON_NO, { buttonMenuButton, originAdmin } from '../focuslock/actions/UPDATE_BUTTON_NO';
import UPDATED_BUTTON_LOCK from '../focuslock/actions/UPDATED_BUTTON_LOCK';

export interface IMenuButton {
    className?: string;
    position?: 'auto' | 'static' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
    text?: string;
    arialabel?: string;
}

export default class MenuButton extends Component<IMenuButton, any> {
    public state = {
        active: false,
    };

    public componentWillUnmount() {
        document.removeEventListener('click', this.onClickOutsideListener);
    }

    public render() {
        const { className, arialabel, text, children } = this.props;

        if (className !== 'list-item-menu-btn') {
            return (
                <div className={className} onMouseLeave={() => {
                    document.addEventListener('click', this.onClickOutsideListener);
                }}>

                    <Wrapper thisButtonNo={buttonMenuButton}
                        updatedlock={() => UPDATED_BUTTON_LOCK({ buttonNo: buttonMenuButton, origin: originAdmin })}>
                        <button
                            aria-label={arialabel ? arialabel : text}
                            className={cx('btn', 'user-btn')}
                            onClick={this.onToggle}>{text}</button>
                    </Wrapper>

                    <FocusLockFocusGuard disabled={!this.state.active} functiondisabled={
                        UPDATE_BUTTON_NO({ buttonNo: buttonMenuButton, origin: originAdmin })}>
                        <div className={cx('button-menu-container')}>
                            <div
                                className={cx('button-menu', this.state.active ? 'wcag-visible' : 'wcag-invisible')}
                            >
                                <button
                                    className={cx('btn', 'icon-btn', 'close')}
                                    aria-label={`Buttonmenu sluiten`}
                                    tabIndex={0}
                                    onClick={this.handleMenuHide}>
                                    <span aria-hidden="true" title="sluiten" className={cx('icon-close')}></span>
                                </button>
                                {children}
                            </div>

                        </div>
                    </FocusLockFocusGuard>
                </div>
            );
        } else {
            return (
                <div className={cx(className)} onMouseLeave={() => {
                    document.addEventListener('click', this.onClickOutsideListener);
                }}>

                    <Wrapper thisButtonNo={buttonMenuButton}
                        updatedlock={() => UPDATED_BUTTON_LOCK({ buttonNo: buttonMenuButton, origin: originAdmin })}>
                        <button
                            aria-label={arialabel ? arialabel : text}
                            className={cx('btn', 'list-item-icon-btn', 'dots_vertical')}
                            onClick={this.onToggle}><span></span></button>
                    </Wrapper>
                    <FocusLockFocusGuard disabled={!this.state.active} functiondisabled={
                        UPDATE_BUTTON_NO({ buttonNo: buttonMenuButton, origin: originAdmin })}>
                        <div className={cx('button-menu-container')}>
                            <div
                                className={cx('button-menu-list-item', this.state.active ? 'wcag-visible' : 'wcag-invisible')}
                            >
                                {children}
                                <button
                                    className={cx('btn', 'icon-btn', 'close')}
                                    aria-label={`Buttonmenu sluiten`}
                                    tabIndex={0}
                                    onClick={this.handleMenuHide}>
                                    <span aria-hidden="true" title="sluiten" className={cx('icon-close')}></span>
                                </button>
                                
                            </div>

                        </div>
                    </FocusLockFocusGuard>
                </div>
            );
        }
    }

    private onClickOutsideListener = () => {
        this.setState({ active: false });
        document.removeEventListener('click', this.onClickOutsideListener);
    }

    private handleMenuHide = () => {
        this.setState({ active: false });
    }

    private onToggle = () => {
        this.setState({ active: !this.state.active });
    }

}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox/menuButton.tsx